import { useEffect } from 'react';

/**
 * Custom hook for managing page titles
 * @param title - The title to set for the current page
 * @param suffix - Optional suffix to append (defaults to "Gemba")
 */
export const usePageTitle = (title: string, suffix: string = 'Gemba') => {
  useEffect(() => {
    const fullTitle = suffix ? `${title} | ${suffix}` : title;
    document.title = fullTitle;
    
    // Cleanup function to reset title if needed
    return () => {
      // Optional: Reset to default title when component unmounts
      // document.title = 'Gemba';
    };
  }, [title, suffix]);
}; 